import React from 'react'
import { Button, Icon, Modal, Input, Grid } from 'semantic-ui-react'


const ShareModal = (props: any) => {
  const [open, setOpen] = React.useState(false);
  let modeURL = new URL(window.location.href);

  // @TODO clean up if not needed
  // let locationURL = new URL(window.location.href);
  // let mode = props.mode;

  //@TODO clean up if not needed
  // function getModeURL() {
  //   modeURL.hash = JSON.stringify(props.getModeParams());
  //   return modeURL.href;
  // }
  //@TODO clean up if not needed
  // function labelForModeURL () {
  //     let theLabel = "Share this mode"
  //     const modeinfo = props.getModeParams();

  //     switch(modeinfo.level) {
  //         case "region":
  //             theLabel = "Share link to " + modeinfo.selected + " region ";
  //             break;
  //         case "country":
  //             theLabel = "Share link to " + modeinfo.selected ;
  //             break;
  //         case "state":
  //                 theLabel = "Share link to " + modeinfo.selected ;
  //                 break;

  //     }
  //     return theLabel;
  // }
  function getViewURL() {
    modeURL.hash = utf8_to_b64(JSON.stringify(props.getViewParams()));
    return modeURL.href;
  }
  //@TODO clean up if not needed
  // function modeURLtoClipboard() {
  //   navigator.clipboard.writeText(getModeURL());
  // }
  function viewURLtoClipboard() {
    navigator.clipboard.writeText(getViewURL());
  }

  return (
    <Modal
      open={open}
      onClose={() => setOpen(false)}
      onOpen={() => setOpen(true)}
      trigger={
        <button className="buttons share_button">
          <Icon name="chain" />
        </button>
      }
    >
      <Modal.Header>Share your current map view</Modal.Header>
      <Modal.Content>
        <Modal.Description>
          {/* <Input
          label={labelForModeURL () }
            action={{
            color: 'teal',
            labelPosition: 'right',
            icon: 'copy',
            content: 'Copy',
            onClick: ()=>{ modeURLtoClipboard();}
            }}
            defaultValue={getModeURL()}
        /> */}
          <Grid columns={2}>
            <Grid.Row>
              <Grid.Column width={13}>
                <Input defaultValue={getViewURL()} />
              </Grid.Column>
              <Grid.Column width={3}>
                <Button
                  animated="vertical"
                  onClick={() => {
                    viewURLtoClipboard();
                  }}
                  color="blue"
                  defaultValue={getViewURL()}
                >
                  <Button.Content hidden>Copy</Button.Content>
                  <Button.Content visible>
                    <Icon name="copy" />
                  </Button.Content>
                </Button>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Modal.Description>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={() => setOpen(false)} color="green">
          Continue <Icon name="chevron right" />
        </Button>
      </Modal.Actions>
    </Modal>
  );
}

export default ShareModal;
function utf8_to_b64( str: string ) {
    return window.btoa(unescape(encodeURIComponent( str )));
  }